import React, {Component} from 'react';
import TestimonialPicture1 from '../../assets/images/testimonial-picture1.png';
import TestimonialPicture2 from '../../assets/images/testimonial-picture2.png';
import TestimonialPicture3 from '../../assets/images/testimonial-picture3.png';
import styles from './TestimonialSection.scss';

export default class PackageBlock extends Component {

   testimonials = [
     {
       imgSrc: TestimonialPicture1,
       name: 'Tim Howard',
       title: 'Marketing Director',
       content: '“Evvnt has proven to be a great tool to cascade event information across many referral\n' +
        'and event sites. We launched an entertainment app using Evvnt to promote the 50-plus launch parties.\n' +
        'On these nights, we saw a strong performance alongside a great level of digital coverage.\n' +
        'It’s an excellent product that saves precious time for our venue managers.”'
     },
     {
       imgSrc: TestimonialPicture2,
       name: 'Hayley Squires',
       title: 'LinkedIn Profiler',
       content: '”We love using Evvnt. The results we can clearly see, more dancing feet in the door, ' +
        'listing used to be a bore and something we do no more! Hurrah! So thanks to the crew for ' +
        'helping us sell more brew. Hat’s off to all of you!”'

     },
     {
       imgSrc: TestimonialPicture3,
       name: 'Aimee Ricca',
       title: 'Strategic Marketing Consultant',
       content: '“Evvnt is the most cost effective solution to have your events listed quickly and ' +
        'effortlessly. It frees up your bandwidth, so that members of your team may focus on other ' +
        'marketing aspects. Evvnt has become a critical element in our event marketing mix and we will' +
        ' continue to use it for every event we hold.”'
     }
   ];

  renderTestimonial = (imgSrc, name, title, content, index) => {
    return (
      <div className="testimonial-block" key={`testimonial-${index}`}>
        <div className="profile">
          <img src={imgSrc}/>
          <div className={styles.name}>
            { name }
          </div>
          <div className={styles.title}>
            { title }
          </div>
        </div>
        <div className={styles.content}>
          { content }
        </div>
      </div>
    );
  }

  render() {
    return (
      <div className={`section ${styles.testimonialSection}`} id="testimonials-section">
        <div className="testimonial-bg"/>
        <div className="header">
          <div className="title">
            What our customers say <br/> about the service!
          </div>
          <div className="separator"/>
        </div>
        <div className="testimonial-container">
          { this.testimonials.map( (testimonial, index) => {
            return this.renderTestimonial(testimonial.imgSrc, testimonial.name, testimonial.title,
              testimonial.content, index);
          })}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// app/client/bundles/EventSubmission/components/snapsell/TestimonialSection.jsx